module.exports = __webpack_public_path__ + "static/media/logo_yukids1.3a0311bf.png";